export const renderValueText = <T>(
  value: T | null | undefined,
  fallback: T
) => {
  return value ?? fallback;
};
